import { render } from "./questionModule.vue?vue&type=template&id=5ab7d175&scoped=true&ts=true&lang=pug"
import script from "./questionModule.vue?vue&type=script&lang=ts"
export * from "./questionModule.vue?vue&type=script&lang=ts"

import "./questionModule.vue?vue&type=style&index=0&id=5ab7d175&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab7d175"]])

export default __exports__